/**
 * @file 右上角用户操作组件
 */
<template>
  <div v-if="userName" class="c-user-info">
    <plv-dropdown>
      <div class="c-user-info__name">{{ userName }}</div>
      <plv-dropdown-menu slot="dropdown">
        <plv-dropdown-item @click="handleDetail">我的资料</plv-dropdown-item>
        <!-- <plv-dropdown-item @click="handleUpdatePsw">修改密码</plv-dropdown-item> -->
        <plv-dropdown-item @click="handleLogout">退出</plv-dropdown-item>
      </plv-dropdown-menu>
    </plv-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    userName: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleDetail() {
      this.$emit('detail');
    },
    handleUpdatePsw() {
      this.$emit('updatePsw');
    },
    handleLogout() {
      this.$store.commit('account/setAccountInfo', null);
      this.$store.commit('common/setXAuthToken', '');
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss">
.c-user-info {
  display: flex;
  align-items: center;
  &__avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &__avatar, &__name {
    cursor: pointer;
  }
}
</style>
